import {Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation} from '@angular/core';
import {TranslateService} from "@ngx-translate/core";
import {environment} from "../../../../../environments/environment";

@Component({
  selector: 'app-project-cards',
  templateUrl: './project-cards.component.html',
  styleUrls: ['./project-cards.component.scss']
})
export class ProjectCardsComponent implements OnInit {
  @Input() projectCards!: any[];

  @Output() sortByChange = new EventEmitter<any>();

  selectedRadioButton: any;

  baseUrl!: string;
  color: string = '#00B47C';

  radioButtons: any[] = [
    {label: this.translate.instant('team_overview_high'),slug: 'highest', id: 'radio1', value: 'DESC'},
    {label: this.translate.instant('team_overview_low'),slug: 'lowest', id: 'radio2', value: 'ASC'}];

  constructor(private translate: TranslateService) { }

  ngOnInit(): void {
    this.selectedRadioButton = this.radioButtons[1];
    this.baseUrl = environment.baseUrl;
    console.log(this.projectCards);
  }

  setFilterByScore() {
    this.sortByChange.emit(this.selectedRadioButton?.value);
  }

}
